import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  { n: "01", word: "Observar", q: "¿Qué está pasando realmente?" },
  { n: "02", word: "Entender", q: "¿Por qué puede estar pasando?" },
  { n: "03", word: "Detectar", q: "¿Qué detalle merece atención?" },
  { n: "04", word: "Conectar", q: "¿Qué tiene esto que ver con el cliente o el negocio?" },
  { n: "05", word: "Crear", q: "¿En qué historia, contenido o acción puede convertirse?" },
];

function StepRow({ step }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.95", "end 0.1"],
  });
  const opacity = useTransform(scrollYProgress, [0, 0.22, 0.75, 1], [0.16, 1, 1, 0.45]);
  const y = useTransform(scrollYProgress, [0, 0.22], [34, 0]);

  return (
    <motion.li
      ref={ref}
      data-testid={`process-step-${step.n}`}
      style={{ opacity, y }}
      className="group grid grid-cols-12 items-baseline gap-4 border-t border-mirian-cream/15 py-10 md:py-16"
    >
      <span className="col-span-3 font-serif text-3xl text-mirian-cream/35 transition-colors duration-500 group-hover:text-mirian-cream/70 md:col-span-2 md:text-6xl">
        {step.n}
      </span>
      <h3 className="col-span-9 font-serif text-3xl uppercase tracking-wide md:col-span-5 md:text-5xl">
        {step.word}
      </h3>
      <p className="col-span-9 col-start-4 mt-2 text-sm text-mirian-cream/60 md:col-span-5 md:col-start-8 md:mt-0 md:text-base">
        {step.q}
      </p>
    </motion.li>
  );
}

export default function Process() {
  return (
    <section
      id="proceso"
      data-testid="process-section"
      className="bg-mirian-wine px-6 py-28 text-mirian-cream md:px-12 md:py-40 lg:px-20"
    >
      <div className="mx-auto max-w-6xl">
        <Eyebrow index="01" label="El proceso" dark />
        <Reveal delay={0.1}>
          <h2 className="mt-10 max-w-3xl font-serif text-4xl leading-[1.1] sm:text-5xl lg:text-6xl">
            Antes de publicar, pasan cinco cosas.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-mirian-cream/55 md:text-base">
            No es un método rígido ni una fórmula. Es simplemente una manera de
            representar cómo suelo aproximarme a un negocio.
          </p>
        </Reveal>

        <ol className="mt-20 md:mt-28">
          {STEPS.map((step) => (
            <StepRow key={step.n} step={step} />
          ))}
        </ol>

        <Reveal delay={0.15} className="mt-16">
          <p className="max-w-xl text-sm leading-relaxed text-mirian-cream/50">
            Los primeros cuatro pasos no se ven en ninguna publicación.
            Pero se notan en todas.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
